module.exports = __webpack_public_path__ + "static/media/business.b05311f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/business.jpg
// module id = 824
// module chunks = 3